import { jobStates } from '@/constants/manageJobsStatus';
import { carrierVerificationStatus } from '@/constants/carrierVerificationStatus';

export const useCarrierVerificationStatus = (highValueStatus, jobStatus) => {
  const hiddenUntilVerified = computed(() => highValueStatus === carrierVerificationStatus.pending);

  const hiddenUntilConfirmed = computed(
    () =>
      jobStatus === jobStates.pending.value &&
      highValueStatus === carrierVerificationStatus.verified,
  );

  const isRequireVerification = computed(
    () => hiddenUntilVerified.value || hiddenUntilConfirmed.value,
  );

  const carrierVerificationStatusLabel = computed(() => {
    if (hiddenUntilVerified.value) {
      return 'Hidden until verified';
    }

    if (hiddenUntilConfirmed.value) {
      return 'Hidden until confirmed';
    }

    return null;
  });

  return {
    isRequireVerification,
    carrierVerificationStatusLabel,
  };
};
